
export async function s3SignedImageUrlToBase64(s3SignedImageUrl: string): Promise<string> {
  const blob = await (await fetch(s3SignedImageUrl)).blob();
  return new Promise((resolve, _) => {
    const reader: FileReader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });
}


export function loadImageFromUrlAsPromise(imgUrl: string): Promise<HTMLImageElement>  {
  return new Promise((resolve) => {
      const image = new Image();
      image.addEventListener('load', () => resolve(image));
      image.src = imgUrl;
  });
}

export function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

// Function to convert data URL to Blob
export function dataURItoBlob(dataURI) {
  var byteString = atob(dataURI.split(',')[1]);
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
}

/**
 * @param filePath
 * @example
 */
export function getFileNameAndExtOfPath(filePath: string) {
  const dotIndex = filePath.lastIndexOf('.');
  const fileName = filePath.substring(0, dotIndex !== -1 ? dotIndex : filePath.length);
  const ext = dotIndex !== -1 ? filePath.substr(dotIndex + 1) : '';
  return {
    fileName,
    ext
  }
}

export function getImageSizeFromDataURL(dataURL) {
  // Extract base64 encoded portion of the data URL
  var base64String = dataURL.split(',')[1];

  // Convert base64 string to binary data
  var binaryData = atob(base64String);

  // Calculate the size of the binary data in bytes
  var dataSize = binaryData.length;

  return dataSize;
}